var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.link
        ? _c(
            "div",
            { staticClass: "link" },
            [
              _c("jade-text", { attrs: { variant: "heading-xsmall" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("link", { link: _vm.formattedLink })) +
                    " "
                ),
              ]),
              _c(
                "jade-button",
                {
                  staticClass: "copy",
                  attrs: { size: "small", variant: "neutral-subtle" },
                  on: {
                    click: function ($event) {
                      return _vm.copyToClipboard(_vm.link)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t(_vm.copiedText)) + " ")]
              ),
              _c("spinner", {
                attrs: { timeoutInMs: _vm.FIVE_MINUTES_IN_MS },
                on: { expired: _vm.reset },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.$slots.trail
        ? _c(
            "div",
            { staticClass: "trail" },
            [
              _vm._t("trail"),
              _c(
                "jade-button",
                {
                  attrs: {
                    variant: "primary-solid",
                    size: "medium",
                    loading: _vm.loading,
                    disabled: _vm.isButtonDisabled,
                  },
                  on: { click: _vm.generateLink },
                },
                [_vm._v(" " + _vm._s(_vm.$t("generate-link")) + " ")]
              ),
            ],
            2
          )
        : _c(
            "jade-button",
            {
              attrs: {
                variant: "primary-solid",
                size: "medium",
                loading: _vm.loading,
                disabled: _vm.isButtonDisabled,
              },
              on: { click: _vm.generateLink },
            },
            [_vm._v(" " + _vm._s(_vm.$t("generate-link")) + " ")]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }